<div class="landing-container">
  <div class="title-container">
    <div class="title left">{{'Landing_Title_Left' | transformText}}</div>
    <div class="title right">{{'Landing_Title_Right' | transformText}}</div>
  </div>
  <div class="image-logo"></div>
</div>